import { WPETypeFile } from "./file/WPETypeFile";
import { WPETypeList } from "./list/WPETypeList";

export const WPEMap = {
  file: WPETypeFile,
  list: WPETypeList,
};
